import React from 'react';
import { testimonials } from '../utils/mockData';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section className="section-padding bg-brand-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4">
            <span className="text-white">What Our Clients </span>
            <span className="text-brand-hot-pink">Say</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Real results from real entrepreneurs who transformed their content game
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="testimonial-card card-hover animate-fadeInUp"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Quote Icon */}
              <div className="flex justify-center mb-4">
                <Quote className="text-brand-hot-pink" size={40} />
              </div>

              {/* Rating */}
              <div className="flex justify-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-brand-glow" size={20} fill="currentColor" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-300 leading-relaxed mb-6 text-center italic">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="text-center pt-4 border-t border-brand-magenta/20">
                <h4 className="text-white font-bold text-lg">{testimonial.name}</h4>
                <p className="text-brand-hot-pink font-semibold text-sm">{testimonial.title}</p>
                <p className="text-gray-400 text-sm">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
